import { Flex, SimpleGrid } from "@chakra-ui/react";
import { InfoCard } from "./infoCard/infoCard";
import { InfoGridProps } from "./utils";

export const InfoGrid = ({ gridData, bootcampType }: InfoGridProps) => {
  return (
    <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4} w="100%">
      {gridData?.map((card, index) => (
        <Flex
          key={index}
          bg="#F4F8FF"
          borderRadius="10px"
          px={6}
          py={4}
          flex={1}
          boxShadow="none"
        >
          <InfoCard
            icon={card.icon}
            text={card.text}
            bgColor="transparent"
            bootcampType={bootcampType}
          />
        </Flex>
      ))}
    </SimpleGrid>
  );
};
